/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useContext, useCallback } from 'react';
import { getString as getStringHelper } from './helper';
import { IFilePickerContextProviderProps, IFilePickerContextValue } from './types';

export const FilePickerContext = createContext<IFilePickerContextValue>({} as IFilePickerContextValue);

export const useFilePickerContext = () => useContext(FilePickerContext);

export const FilePickerContextProvider = ({
  children,
  i18n,
  customStrings,
}: IFilePickerContextProviderProps) => {
  const getString = useCallback(
    (key: string) => getStringHelper({ customStrings, i18n, key }),
    [i18n, customStrings]
  );

  return (
    <FilePickerContext.Provider value={{ getString }}>
      {children}
    </FilePickerContext.Provider>
  );
};
